import React from 'react';

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  pill?: boolean;
  bg?: string;
}

function Badge({ pill, bg, className = '', children, ...rest }: BadgeProps) {
  const bgMap: Record<string, string> = {
    primary: 'badge-primary',
    secondary: 'badge-neutral',
    success: 'badge-success',
    danger: 'badge-error',
    warning: 'badge-warning',
    dark: 'badge-neutral',
  };
  const bgClass = bg ? (bgMap[bg] || '') : '';
  return (
    <span className={`badge ${bgClass} ${className}`.trim()} {...rest}>
      {children}
    </span>
  );
}

export default Badge;
